import Vue from 'vue';

Vue.filter('currencyMask', value => {
  if (value) {
    let str = value.toString();

    if (!str.match(/[,.]/)) {
      // Exemplo 3000
      str += '00';
    }
    if (str.charAt(str.length - 2) == '.') {
      // Exemplo 3000.0
      str += '0';
    }
    if (str.match(/[,.]/)) {
      // Exemplo 3000.00
      str = str.replace(/[\D]+/g, '');
    }

    while (str.startsWith('0') && str.length > 3) {
      const n = str.length;
      str = str.slice(1, n - 1);
    }

    const formated = str.replace(/([0-9]{2})$/g, ',$1');

    if (formated.length > 12) {
      return formated.replace(/([0-9]{3})([0-9]{3})([0-9]{3}),([0-9]{2})$/g, '.$1.$2.$3,$4');
    }
    if (formated.length > 9) {
      return formated.replace(/([0-9]{3})([0-9]{3}),([0-9]{2})$/g, '.$1.$2,$3');
    }
    if (formated.length > 6) {
      return formated.replace(/([0-9]{3}),([0-9]{2})$/g, '.$1,$2');
    }
    return formated;
  }
  return null;
});
